import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getAuthToken } from "../../Api";

const PrivateRoute = () => {
  const token = getAuthToken();
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};
export default PrivateRoute;
